







































































































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mutations, Actions, Views, ViewModes } from '@/ts/store/Constants';
import InputField from '@/ts/InputField';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import MobileLoginErrorDialog from '@/components/Dialogs/MobileLoginErrorDialog.vue';
import DesktopLoginErrorDialog from '@/components/Dialogs/DesktopLoginErrorDialog.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

@Component({
    computed: {
        ...mapGetters({
            userIsLoggedIn: 'User/userIsLoggedIn',
        }),
    },
    methods: {
        ...mapActions([Actions.LOG_IN]),
    },
    components: {
        MobileLoginErrorDialog,
        ErrorMessage,
        DesktopLoginErrorDialog,
    },
})
export default class LogIn extends Mixins(InputFieldMethods, DeviceMethods) {
    constructor() {
        super();
    }

    public created() {
        this.inputs['hococo-form-login-email'] = new InputField('hococo-form-login-email');
        this.inputs['hococo-form-login-password'] = new InputField('hococo-form-login-password');

        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);

        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.LogIn,
            viewMode: ViewModes.LogIn.LogInView,
        });
    }

    public showTerms() {
        this.$store.commit(Mutations.SHOW_TERMS);
    }

    private inputValidates(): boolean {
        let isValid = true;

        if (this.getResponseCode !== null && this.getResponseCode !== 200) {
            isValid = false;
        }

        return isValid;
    }

    private logIn() {
        this.$store.dispatch(Actions.LOG_IN, this);
    }

    get email(): string {
        return this.$store.getters['User/getEmail'];
    }

    set email(value: string) {
        this.$store.commit(Mutations.UPDATE_PASSWORD_EMAIL, value);
        return;
    }

    get password(): string {
        return this.$store.getters['User/getPassword'];
    }

    set password(value: string) {
        this.$store.commit(Mutations.UPDATE_PASSWORD, value);
        return;
    }

    get getResponseCode(): number {
        return this.$store.getters['User/getResponseCode'];
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get errorView() {
        return (this.view.viewMode === ViewModes.LogIn.ErrorView);
    }
}
